import React, { useEffect, useState } from 'react'
import { ReactComponent as Sec1 } from '@/assets/svg/sec_1.svg'
import { ReactComponent as DecorativeIcon2 } from '@/assets/svg/decorative-icon-2.svg'
import { ReactComponent as DecorativeIcon3 } from '@/assets/svg/decorative-icon-3.svg'
import { ReactComponent as DecorativeIcon4 } from '@/assets/svg/decorative-icon-4.svg'
import { ReactComponent as DecorativeIcon5 } from '@/assets/svg/decorative-icon-5.svg'
import logo from '@/assets/img/logo.png'
import homeLogo from '@/assets/img/banner-right-logo.png'

import banner_bg from '@/assets/background/banner_bg.png'
import ball_bg from '@/assets/background/ball_bg.png'
import data_bg from '@/assets/background/data_statistic.png'
import system_bg from '@/assets/background/data_system2.png'

import BallComponent from './components/BallComponent'
import StatisticComponent from './components/StatisticComponent'
import SystemComponent from './components/SystemComponent'
import Footer from './components/Footer'
import { parse } from 'querystring'
import styles from './index.less'

const serverTypeList = [
  {
    img: <Sec1 />,
    text: '构建服务',
  },
  {
    img: <DecorativeIcon2 />,
    text: '测试服务',
  },
  {
    img: <DecorativeIcon3 />,
    text: '镜像服务',
  },
  {
    img: <DecorativeIcon4 />,
    text: '安全服务',
  },
  {
    img: <DecorativeIcon5 />,
    text: '资源服务',
  },
]

export default () => {
  // 是否显示 滚动数字 组件
  const [showScrollNumber, setShowScrollNumber] = useState(false)
  const [divHeight, setDivHeight] = useState(0)
  const suffix = 'home_content'

  const onClick = () => {
    const { search = '' } = window.location
    const hashSearchString = search.split('?')[1] || ''
    const resultQuery = parse(hashSearchString).callback
    const reg = /(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(?::\d+)?|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/
    // case1.指定了跳转页面
    if (reg.test(resultQuery)) {
      window.location.href = resultQuery
    } else {
      // case2.没指定跳转页面的情况
      window.location.href = 'https://openanolis.cn/'
    }
  }

  const callback = (info) => {
    const { parentHeight } = info
    setDivHeight(parentHeight)
  }

  const calcDistanceTop = () => {
    let anchorElement = document.getElementById('home_content_statistic')
    if (anchorElement) {
      // 判断元素距离顶部的滚动距离范围。
      const scrollDistance = anchorElement.offsetTop - window.pageYOffset
      if (scrollDistance > -100 && scrollDistance <= 460) {
        setShowScrollNumber(true)
      }
    }
  }
  /**
   * 鼠标滚轮事件
   */
  useEffect(() => {
    const timer = setInterval(() => {
      calcDistanceTop()
    }, 100)
    return () => {
      clearInterval(timer)
    }
  }, [])

  return (
    <div className={styles['home-root']}>
      <div className={styles[`${suffix}_platform`]} id={`${suffix}_platform`}>
        <div
          className={`${styles.container} ${styles.layout}`}
          style={{
            background: `url(${banner_bg}) no-repeat left center / 100% 100%`,
          }}
        >
          <div className={styles.left}>
            {/* <div className={styles.callback_btn}>
              <button onClick={callbackUrl}>
                <span
                >
                  <ArrowLeftOutlined />
                  返回
                </span>
              </button>
            </div> */}
            <img
              src={logo}
              className={styles.openAnolis_logo}
              onClick={onClick}
            />
            <div className={styles.header_title}>
              开发者服务平台
              <span>devFree</span>
            </div>
            <p>
              致力于打造业界最完备的开发者自助服务体系，为开发者提供全流程的开源项目支撑{' '}
            </p>
          </div>
          <div className={styles.right}>
            <div className={styles.right_position}>
              <img src={homeLogo} className={styles.home_logo} />
              <div className={styles.yellow_circle}>个人开发者</div>
              <div className={styles.red_circle}>合作企业</div>
              <div className={styles.blur_circle}>社区理事单位</div>
            </div>
          </div>
        </div>
      </div>

      <p className={styles.title_efficient} style={{ color: '#FFF' }}>
        让开发更简单、更高效
      </p>
      <div
        className={styles[`${suffix}_efficient`]}
        id={`${suffix}_efficient`}
        style={{ background: `url(${ball_bg}) no-repeat center / 115% 105%` }}
      >
        <div className={`${styles.container} ${styles.layout}`}>
          <BallComponent callback={callback} />
        </div>
      </div>

      <div
        className={styles[`${suffix}_statistic`]}
        id={`${suffix}_statistic`}
        style={{ background: `url(${data_bg}) no-repeat center/ 113% 50%` }}
      >
        <div className={`${styles.container} ${styles.layout}`}>
          <StatisticComponent callback={callback} install={showScrollNumber} />
        </div>
      </div>

      <div
        className={styles[`${suffix}_system`]}
        id={`${suffix}_system`}
        style={{
          background: `url(${system_bg}) no-repeat left center / 100% 100%`,
        }}
      >
        <div className={`${styles.container} ${styles.layout}`}>
          <p className={styles.title} style={{ color: '#FFF' }}>
            完备的自助服务体系
          </p>
          <SystemComponent callback={callback} />
        </div>
      </div>

      <div className={styles[`${suffix}_footer`]} id={`${suffix}_footer`}>
        <div className={`${styles.container} ${styles.layout}`}>
          <Footer />
        </div>
      </div>
    </div>
  )
}
